import { render, staticRenderFns } from "./CompetentAuthorityForm.vue?vue&type=template&id=698b022a&scoped=true&"
import script from "./CompetentAuthorityForm.vue?vue&type=script&lang=js&"
export * from "./CompetentAuthorityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698b022a",
  null
  
)

export default component.exports